// extracted by mini-css-extract-plugin
module.exports = {"ageGatePage":"AgeGate_ageGatePage__ilJJw"};